import { gql } from '@apollo/client';
export const SITE_PERMISSION_FIELDS = gql`
  fragment SitePermission on PortalSitePermissionDTO {
    id
    hasAccess
  }
`;
export const NEWO_CONTEXT_FIELDS = gql`
  ${SITE_PERMISSION_FIELDS}
  fragment NewoContext on PortalCoreElearningContextDTO {
    hasAcademicRecords
    canAccessSitesByDefault
    sitePermissionList {
      ...SitePermission
    }
    studentExternalId
    idStudent
  }
`;